import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class FormDataService<T> {
    private formData: T = {} as T;

    setFormData(data: T) {
        this.formData = { ...data };
    }

    getFormData(): T {
        return { ...this.formData };
    }
}
